var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-default is-bold"},[_c('div',{staticClass:"hero-body"},[_c('maps',{attrs:{"fullscreen":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }